require.config({
    paths : {
        "view-templates"    : "responsive-gameday/views/templates",
        // "view-templates"    : "responsive-gameday/views/gumbo_templates",
        "moment"            : "moment/moment",
        "WaxMustache"       : "hogan/web/builds/3.0.2/hogan-3.0.2.amd",
        "text"              : "text/text"
    },
    packages: [{
        name : "GameDayCore",
        location : "responsive-gameday-core/src/js"
    }]  
});

define('responsive-gameday/bootstrap',['require','exports','module','GameDayCore','message-service/message-service','GameDayCore/GDModel/enums/events/EventTypes','./views/Monitor/StateMonitor','responsive-gameday-game-switch-mediator/responsive-gameday-game-switch-mediator','./views/distributors/DataDistributor','gameday-device-interaction/type','./utils/ui-log'],function(require,exports,module){
    var GameDayCore = require('GameDayCore'),
        MessageService = require( "message-service/message-service" ),
        eventEnums = require('GameDayCore/GDModel/enums/events/EventTypes'),
        StateMonitor = require( './views/Monitor/StateMonitor' ),
        GameSwitchMediator = require("responsive-gameday-game-switch-mediator/responsive-gameday-game-switch-mediator"),
        DataDistributor = require('./views/distributors/DataDistributor'),
        deviceInteractionType = require( "gameday-device-interaction/type" ),
        uilog = require('./utils/ui-log');

    return function(viewBootstrap,opts){
            // Load an optional global config via require.config
        var config=module.config(),
            key;
        opts=opts||{}

        if(typeof opts === "string") {
            config.game=opts;
            opts={}
        }

            //Merge in config options from opts
        for(key in opts){
            if(opts.hasOwnProperty(key));
            config[key]=opts[key];
        }

            //Set the log level for responsive-gameday's logger to match GDC
        uilog.setLevel(config.logging);
        uilog.info('responsive bootstrap',config);

            //Set the shared device type for deviceInteractions.
        deviceInteractionType(config.deviceInteractionType);

        function viewBootstrapListener($evt, $args) {

            uilog.log("init view!");
            GameDayCore.removeListener(eventEnums.INIT_DATA_LOADED, viewBootstrapListener);
            if (config.gumboMode !== true) {
                uilog.info("StateMonitor init")
                StateMonitor.init();
            } else {
                uilog.info("DataDistributor init")
                DataDistributor.init();
            }
            viewBootstrap();
            MessageService.publish("responsive-gameday-ready");
        }
            //Init listener
        GameDayCore.addListener(eventEnums.INIT_DATA_LOADED, viewBootstrapListener);
            //Start it up
        GameDayCore.init(config.game,config);
    }

});
